
// Keep this in sync with Skilld!!!!!
import _ from 'underscore';

declare interface Levels {
  [id: string]: string;
}

declare interface LevelsReverse {
  [id: string]: any;
}

declare interface SeniorLevels {
  [id: string]: number;
}

export class EnumConfig {   // Should be fetched from skilld, atm we don't do that yet.
  public static reverseLevels(hash: any): LevelsReverse {
    return (_.object(_.values(hash), _.keys(hash)));
  }

  public static languageLevels: Levels = {
    "Notions": "0",
    "Basic": "1",
    "Good": "2",
    "Very good": "3",
    "Mother tongue": "4"
  };

  public static seniorLevels: SeniorLevels = {
    "JR": 0,
    "C1": 1,
    "M1": 1,
    "C2": 2,
    "M2": 2,
    "C3": 2.5,
    "M3": 2.5,
    "SC1": 3,
    "S1": 3,
    "SC2": 4,
    "S2": 4,
    "SC3": 4.5,
    "S3": 4.5,
    "PR1": 5,
    "PR2": 6,
    "PR3": 7
  };
}
